export function getAppConfig() {
    return window['ACC'].config || null;
}
